import { useRouter } from 'next/router';
import { useEffect } from 'react';

enum DefaultSti {
  PC = 'search_flights',
  MOBILE = 'm_search_flights',
}

type AirlineIndex = 'domestic' | 'international';
type FromAirlineIndex = { [key in AirlineIndex]: string };
const NlogAirlineType: FromAirlineIndex = {
  domestic: 'd',
  international: 'i',
};

enum NlogViewType {
  LIST = 'out',
  DETAIL = 'detail',
  HIDDEN = 'more',
}

declare global {
  interface Window {
    ntm: any;
  }
}

const useNlogPageView = (isMobile: boolean) => {
  const {
    query: { selectedFlight, samePriceOrgSch, routes },
    pathname,
    asPath,
  } = useRouter();

  useEffect(() => {
    const defaultSti = isMobile ? DefaultSti.MOBILE : DefaultSti.PC;
    const [, , airlineType] = pathname.split('/');

    let sti = `${defaultSti}`;
    let isSendLog = true;

    if (NlogAirlineType[airlineType as AirlineIndex]) {
      sti += `_${NlogAirlineType[airlineType as AirlineIndex]}`;
      if (selectedFlight) {
        if ((selectedFlight as string).split(',').length === routes?.length) {
          sti += `_${NlogViewType.DETAIL}`;
        } else {
          isSendLog = false; // 모든 여정이 선택되지 않으면 로그 발송하지 않음
        }
      } else if (samePriceOrgSch && samePriceOrgSch.length > 0) {
        sti += `_${NlogViewType.HIDDEN}`;
      } else {
        sti += `_${NlogViewType.LIST}`;
      }
    }

    if (isSendLog) {
      window.ntm.push({
        event: 'pageview',
        sti,
      });
    }
  }, [asPath]);
};

export default useNlogPageView;
